import { Timestamp } from 'firebase/firestore';
import { Mapper } from '../../core/src';
import { PrivateTimestampDto, TimestampDto } from '../data/firestore.entity';

export class TimestampDtoToTimestampMapper
  implements Mapper<TimestampDto | PrivateTimestampDto, Timestamp>
{
  public map(from: TimestampDto | PrivateTimestampDto): Timestamp {
    if ('_seconds' in from) {
      return new Timestamp(from._seconds, from._nanoseconds);
    } else {
      return new Timestamp(from.seconds, from.nanoseconds);
    }
  }
}
